import { j as i } from "../../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../../index-CROKJrb5.js";
import { c as s, f as e } from "../../../../create-component-CBAeEoQ6.js";
import { CardPricing as c } from "../../CardPricing/index.js";
const d = s(
  "TextCardPricing",
  e(
    ({ children: r, className: o, ...t }, a) => /* @__PURE__ */ i.jsx(c, { ref: a, className: m("cur-mb-4", o), ...t, children: r })
  )
);
export {
  d as TextCardPricing
};
//# sourceMappingURL=index.js.map
